var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroupIconSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7 17.6L13 14M21.2 17.7L19 14M18 22.5H14M18 22.5C18 25.5376 20.4624 28 23.5 28C26.5376 28 29 25.5376 29 22.5C29 19.4624 26.5376 17 23.5 17C20.4624 17 18 19.4624 18 22.5ZM14 22.5C14 25.5376 11.5376 28 8.5 28C5.46243 28 3 25.5376 3 22.5C3 19.4624 5.46243 17 8.5 17C11.5376 17 14 19.4624 14 22.5ZM21.5 9.5C21.5 12.5376 19.0376 15 16 15C12.9624 15 10.5 12.5376 10.5 9.5C10.5 6.46243 12.9624 4 16 4C19.0376 4 21.5 6.46243 21.5 9.5Z",
    stroke: "var(--color, #FF7100)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 19L6 23L8 23.5L7.5 26L11 22.5L9 21.5L9.5 19Z",
    stroke: "var(--color, #FF7100)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 19L21 23L23 23.5L22.5 26L26 22.5L24 21.5L24.5 19Z",
    stroke: "var(--color, #FF7100)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7 6L13.2 10L15.2 10.5L14.7 13L18.2 9.5L16.2 8.5L16.7 6Z",
    stroke: "var(--color, #FF7100)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupIconSmall);
export default __webpack_public_path__ + "static/media/group-icon-small.7842b9f33ac879cb2ee7dc4cf9df06dc.svg";
export { ForwardRef as ReactComponent };